import type { ConsultationDetails } from '..';

const isValidAppointment = (consultation: ConsultationDetails) => {
  const { appointment, confirmationNumber } = consultation || {};
  const { appointmentDate } = appointment || {};
  return (
    !!appointment &&
    !!confirmationNumber &&
    !!appointmentDate &&
    new Date(appointmentDate).getTime() > Date.now()
  );
};

export function filterConsultations(
  appointments: ConsultationDetails[],
  topic?: string,
) {
  let validAppointments = appointments.filter(isValidAppointment);

  if (topic) {
    validAppointments = validAppointments.filter(
      (appointment) =>
        appointment?.topic?.name?.toLowerCase() === topic.toLowerCase(),
    );
  }

  return validAppointments.sort(
    ({ appointment: appointmentA }, { appointment: appointmentB }) =>
      new Date(appointmentA!.appointmentDate).getTime() -
      new Date(appointmentB!.appointmentDate).getTime(),
  );
}
